import { ImageAnnotationRecord } from "models/view-models/block-configurations/image-annotation-record";
import { ImageBlockConfigurationRecord } from "models/view-models/block-configurations/image-block-configuration-record";
import { useState } from "react";
import EventUtils from "utilities/events/event-utils";
import useImageAnnotations from "utilities/hooks/domain/notebooks/pages/use-image-annotations";
import useModalActions from "utilities/hooks/use-modal-actions";
const IMAGE_ANNOTATION_ICON_SIZE = 24;

const useManageImageAnnotations = (
    imageBlockConfiguration?: ImageBlockConfigurationRecord
) => {
    const [activeImageAnnotation, setActiveImageAnnotation] =
        useState<ImageAnnotationRecord>();
    const { handleOpen, handleClose, isOpen } = useModalActions();
    const { updateImageAnnotation } = useImageAnnotations();

    const handleStartNewImageAnnotation = (
        e: React.MouseEvent<HTMLImageElement, MouseEvent>
    ) => {
        const coordinates = EventUtils.getRelativeClickCoordinates(
            e,
            IMAGE_ANNOTATION_ICON_SIZE
        );
        const newImageAnnotation = new ImageAnnotationRecord().with({
            imageBlockId: imageBlockConfiguration?.id,
            coordinateX: coordinates.percentageX,
            coordinateY: coordinates.percentageY,
        });
        setActiveImageAnnotation(newImageAnnotation);
        handleOpen();
    };

    const handleEditExistingImageAnnotation = (
        annotationToEdit: ImageAnnotationRecord
    ) => {
        setActiveImageAnnotation(annotationToEdit);
        handleOpen();
    };

    const reset = () => {
        setActiveImageAnnotation(undefined);
        handleClose();
    };

    const onMoveStart = (annotation: ImageAnnotationRecord) => {
        setActiveImageAnnotation(annotation);
    };

    const onMoveEnd = () => {
        setActiveImageAnnotation(undefined);
    };

    const moveAnnotationToNewPosition = (
        e: React.DragEvent<HTMLImageElement>
    ) => {
        if (!activeImageAnnotation) return;

        const { percentageX, percentageY } =
            EventUtils.getRelativeClickCoordinates(
                e,
                IMAGE_ANNOTATION_ICON_SIZE
            );

        const annotationWithNewPosition = activeImageAnnotation.with({
            coordinateX: percentageX,
            coordinateY: percentageY,
        });

        // Not awaiting so that annotation is optimistically placed in new location
        updateImageAnnotation(annotationWithNewPosition);
        return annotationWithNewPosition;
    };

    return {
        activeImageAnnotation,
        handleStartNewImageAnnotation,
        handleEditExistingImageAnnotation,
        showImageAnnotationModal: isOpen,
        closeImageAnnotationModal: handleClose,
        openImageAnnotationModal: handleOpen,
        onMoveEnd,
        onMoveStart,
        moveAnnotationToNewPosition,
        reset,
    };
};
export default useManageImageAnnotations;
